import { Typography } from '@mui/material';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { getIntlLocale } from 'utils';

import styles from './MessageInfo.module.scss';

type MessageInfoProps = {
  dateCreated: Date;
  isMy: boolean;
  author: string;
  forceLightTheme?: boolean;
};

export function MessageInfo({ dateCreated, isMy, author, forceLightTheme }: MessageInfoProps): JSX.Element {
  const { i18n } = useTranslation();
  const locale = getIntlLocale(i18n.resolvedLanguage || i18n.language || 'en');

  const getMessageDateString = (date: Date): string => {
    return new Intl.DateTimeFormat(locale, {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    }).format(date);
  };

  return (
    <div className={classnames(styles.messageDate, isMy ? styles.messageDateMy : styles.messageDateOther)}>
      {author ? (
        <Typography
          component='p'
          variant='body6'
          className={styles.messageDateText}
          sx={forceLightTheme ? { color: '#626363' } : undefined}
        >
          <>
            <b className={styles.author}>{author}</b> {getMessageDateString(dateCreated)}
          </>
        </Typography>
      ) : (
        <Typography
          component='p'
          variant='body6'
          className={styles.messageDateText}
          sx={forceLightTheme ? { color: '#626363' } : undefined}
        >
          {getMessageDateString(dateCreated)}
        </Typography>
      )}
    </div>
  );
}
